import React from 'react'
import { Footer } from 'components'
import { ContestRules, SweepstakesRules } from './content'
import styles from './styles.module.scss'

const SweepstakesRulePage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <SweepstakesRules />
        <div className="mt-32">
          <Footer alightCenter />
        </div>
      </div>
    </div>
  )
}

export default SweepstakesRulePage
